import { SxProps } from '@mui/material';

export const ContainerSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

export const SettingsButtonSx: SxProps = {
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  minWidth: 'unset',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '5px',
  paddingBottom: '5px',
  color: '#000000',
  borderColor: '#000000',
  '& .MuiButton-startIcon': {
    marginRight: '8px'
  },
  '&:hover': {
    borderColor: '#000000',
    backgroundColor: 'rgba(0, 0, 0, 0.04)'
  }
};

export const JamfAssetsTitleSx = {
  fontWeight: 'bold',
  fontSize: '16px',
  textAlign: 'left',
  marginBottom: 1,
};

export const LastSyncTitleSx = {
  fontWeight: 'bold',
  fontSize: '16px',
  textAlign: 'left',
  marginBottom: 1,
};
